import {GenericList} from './GenericList';
import {Customer} from '../../models/Customer';

export class CustomerList extends GenericList<Customer> {}
